<template>
  <div>
    <LargeSidebar
      v-bind:links="links"
      :isAdmin="isAdmin"
    />
    <transition name="enter-left">
      <SmallSidebar
        class="px-2 position-relative"
        v-bind:links="links"
        :isAdmin="isAdmin"
        v-if="shouldDisplay"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LargeSidebar from './LargeSidebar'
import SmallSidebar from './SmallSidebar'

export default {
  name: 'SidebarContainer',
  components: {
    LargeSidebar,
    SmallSidebar
  },
  data() {
    return {
      title: 'SidebarContainer',
      isDietitian: true,
      shouldDisplay: false,
      links: [
        { display: 'Account', route: '/account', icon: 'house', access: 'all', mobile: true },
        { display: 'Messaging', route: '/messages', icon: 'chat-dots', access: 'all', mobile: true },
        { display: 'Users', route: '/user', icon: 'person', access: 'all', mobile: false },
        { display: 'Groups', route: '/group', icon: 'people', access: 'all', mobile: false },
        { display: 'Dietitians', route: '/dietitian', icon: 'egg-fried', access: 'admin', mobile: false },
        { display: 'Share Files', route: '/file', icon: 'folder2', access: 'all', mobile: true }
        // { display: 'Shared Content', route: '/shared-content', icon: 'paperclip', access: 'admin', mobile: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['getMyInfo', 'displayMobileNav']),
    isAdmin() {
      return this.getMyInfo && this.getMyInfo.hasRoles
    }
  },
  methods: {
    updateDisplay() {
      if (window.innerWidth < 1200) {
        if (window.innerWidth > 768) {
          this.shouldDisplay = true
        } else {
          this.shouldDisplay = this.displayMobileNav
        }
      } else {
        this.shouldDisplay = false
      }
    }
  },
  created() {
    this.updateDisplay()
    window.addEventListener('resize', this.updateDisplay)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDisplay)
  },
  watch: {
    displayMobileNav() { this.updateDisplay() }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Layout/Sidebar/SidebarContainer.vue?382009a9